<div *ngIf="!showDisclaimer" class="home-mainsearch-container container-fluid main top-spacing-50">
  <!-- // Standard search -->
  <div class="home-mainsearch">
  	<span class="home-brand-group">
    	<div class="center-block bottom-spacing main-logo home-brand" role="presentation" aria-hidden="true"></div>
		<span class="home-brand-copy-text"></span>
	</span>
    <div class="home-search-input-container row top-spacing-50 bottom-spacing-50">
      <div class="home-search-input-inner-container col-md-7 col-md-offset-2 col-sm-7 col-sm-offset-2">
        <div>
          <div class='input-group input-group-lg'>
            <input [(ngModel)]='query' 
            	(keyup.enter)="search()" 
            	type="search"
                class="form-control" 
                [attr.aria-label]="LOCALIZATION.searchPlaceholder" 
                placeholder="{{LOCALIZATION.searchPlaceholder}}"
                title="{{LOCALIZATION.searchPlaceholder}}" />
            <div class="input-group-btn">
				  <select class="form-control query-type-select hidden-xs" [(ngModel)]="type" [attr.aria-label]="LOCALIZATION.queryType">
				       <option value="0">{{LOCALIZATION.exactMatch}}</option>
				       <option value="16">{{LOCALIZATION.boolean}}</option>
				       <option value="32">{{LOCALIZATION.concept}}</option>
				       <option value="64">{{LOCALIZATION.pattern}}</option>
			      </select>                 
	              <button *ngIf='query != null && query.length > 0' 
	              		(click)='query=""' 
	              		class='btn btn-danger hidden-xs'
	                	title="{{LOCALIZATION.clearSearch}}">
	                      <i class="fas fa-times" aria-hidden="true"></i> 
	              </button>
	              <button class='btn btn-primary' 
	              		(click)='search()' 
	              		title="{{LOCALIZATION.search}}"> 
	              	<i class="fas fa-search" aria-hidden="true"></i> 
	              </button>
            </div>
          </div>
          <div class="home-advanced-container">
             <button class='btn btn-primary' 
             		(click)='advancedSearch()' 
             		title="{{LOCALIZATION.advancedSearch}}">
             		{{LOCALIZATION.advancedSearch}} 
             </button>
             <div class="home-advanced-copy"></div>
          </div>          
        </div>
      </div>
    </div>
  </div>
  
  <div *ngIf="!dashboardEnabled" class="home-mainsearch-extra">
      <!-- // Quick search buttons -->
      <div class="home-quicksearch col-md-12 text-center">
        <div [ngClass]="{'btn-group-vertical': isMobile, 'bottom-spacing-10': isMobile,
        	 'bottom-spacing-50': !isMobile, 'top-spacing': !isMobile}">
			<ng-container *ngFor="let btn of quickSearch">
	          	<button 
	          		*ngIf="btn.enabled"
	          		[title]="btn.displayName"
	          		class="btn btn-accent btn-lg search-button"
	            	(click)="doQuickSearch(btn)">
	            		{{ btn.displayName }}
	            </button>			    
			</ng-container>                
        </div>
      </div>
      <div class="home-leadtext container-fluid top-spacing">
	      <div class="row top-spacing">
	        <div class="col-md-8 col-sm-12 col-xs-12 col-md-offset-2 text-center">
	          <p class="lead">{{LOCALIZATION.homeLeadText}}</p>
	        </div>
	      </div>
      </div>
  </div>
  
  <!-- // Dashboard view -->
  <div *ngIf="dashboardEnabled">
  	<kv-dashboard [userView]="view"></kv-dashboard>
  </div> 
</div>
<div *ngIf="showDisclaimer" class="container-fluid main">
	<ng-container *ngIf="htmlContent">
		<div [innerHTML]="htmlContent"></div>
		<button class="btn btn-default" (click)="acceptDisclaimer()">{{LOCALIZATION.accept || 'Accept'}}</button>
	</ng-container>	
	<h1 *ngIf="!htmlContent">{{LOCALIZATION.disclaimerError}}</h1>
</div>
